export const TOTAL_COUNT_USERS = 'TOTAL_COUNT_USERS';
export const REQUEST_API_START_USERS = 'REQUEST_API_START_USERS';
export const REQUEST_API_SUCCESS_USERS = 'REQUEST_API_SUCCESS_USERS';
export const REQUEST_API_ERROR_USERS = 'REQUEST_API_ERROR_USERS';
export const REQUEST_GET_USERS_LIST_START = 'REQUEST_GET_USERS_LIST_START';
export const REQUEST_GET_USERS_LIST_SUCCESS = 'REQUEST_GET_USERS_LIST_SUCCESS';
export const REQUEST_GET_USERS_LIST_ERROR = 'REQUEST_GET_USERS_LIST_ERROR';
export const REQUEST_GET_LIST_FILTER_USERS_START = 'REQUEST_GET_LIST_FILTER_USERS_START';
export const REQUEST_GET_LIST_FILTER_USERS_SUCCESS = 'REQUEST_GET_LIST_FILTER_USERS_SUCCESS';
export const REQUEST_GET_LIST_FILTER_USERS_ERROR = 'REQUEST_GET_LIST_FILTER_USERS_ERROR';
export const REQUEST_CREATE_USERS = 'REQUEST_CREATE_USERS';
export const REQUEST_UPDATE_BY_ID = 'REQUEST_UPDATE_BY_ID';
export const REQUEST_DELETE_BY_ID = 'REQUEST_DELETE_BY_ID';
export const REQUEST_GET_USER_SUCCESS = 'REQUEST_GET_USER_SUCCESS';
export const REQUEST_CREATE_USER = 'REQUEST_CREATE_USER';
export const SELECTED_ITEM = 'SELECTED_ITEM';
